// helpers
export function formatNumber(n) {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("ru-RU").format(n);
}

export function formatDate(s) {
  if (!s) return "—";
  try {
    const d = typeof s === "string" ? new Date(s.replace(" ", "T") + (s.endsWith("Z") ? "" : "Z")) : new Date(s);
    return d.toLocaleString("ru-RU", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return s;
  }
}

export function formatRelative(s) {
  if (!s) return "—";
  try {
    const d = new Date(s.replace(" ", "T") + (s.endsWith("Z") ? "" : "Z"));
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "только что";
    if (diff < 3600) return `${Math.floor(diff / 60)} мин назад`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ч назад`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} дн назад`;
    return d.toLocaleDateString("ru-RU");
  } catch {
    return s;
  }
}

export function initials(profile) {
  const fn = profile?.first_name || "";
  const ln = profile?.last_name || "";
  const un = profile?.username || "";
  const a = (fn[0] || un[0] || "?").toUpperCase();
  const b = (ln[0] || "").toUpperCase();
  return (a + b) || "?";
}

export function displayName(profile) {
  return (
    [profile?.first_name, profile?.last_name].filter(Boolean).join(" ") ||
    (profile?.username ? "@" + profile.username : null) ||
    "ID " + (profile?.user_id ?? "—")
  );
}

export function tagTypeLabel(t) {
  return (
    { event: "Событие", product: "Продукт", status: "Статус", source: "Источник", custom: "Произв." }[t] || t
  );
}

export const ROLE_LABEL = {
  super_admin: "Главный админ",
  admin: "Админ",
  viewer: "Только просмотр",
};
